import * as React from 'react';

const SidebarIndicator: React.FunctionComponent = () => {
    return (<svg width="27" height="41" viewBox="0 0 27 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.330078 40.068C2.1351 40.6033 4.04669 40.8906 6.02539 40.8906C17.0711 40.8906 26.0254 31.9363 26.0254 20.8906C26.0254 9.84493 17.0711 0.890625 6.02539 0.890625C4.04669 0.890625 2.1351 1.17797 0.330078 1.71321V40.068Z" fill="#FF5454" />
    </svg>);
};

export default SidebarIndicator;
